import React, { useEffect, useState } from 'react';
import { CheckCircle, X } from 'lucide-react';
const RECENT_PURCHASES = [{
  name: 'María L.',
  city: 'Buenos Aires, Argentina'
}, {
  name: 'Carlos R.',
  city: 'Córdoba, Argentina'
}, {
  name: 'Ana P.',
  city: 'Santiago, Chile'
}, {
  name: 'Laura G.',
  city: 'Montevideo, Uruguay'
}, {
  name: 'Sofía M.',
  city: 'Rosario, Argentina'
}, {
  name: 'Diego F.',
  city: 'Mendoza, Argentina'
}, {
  name: 'Valentina S.',
  city: 'Lima, Perú'
}, {
  name: 'Juan P.',
  city: 'Madrid, España'
}, {
  name: 'Lucía B.',
  city: 'La Plata, Argentina'
}, {
  name: 'Martín T.',
  city: 'Asunción, Paraguay'
}];
export function PurchaseNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(RECENT_PURCHASES[0]);
  useEffect(() => {
    // Show first notification after 5 seconds
    const initialTimer = setTimeout(() => {
      setIsVisible(true);
    }, 5000);
    // Cycle notifications every 20 seconds
    const cycleTimer = setInterval(() => {
      setIsVisible(false);
      setTimeout(() => {
        const randomPurchase = RECENT_PURCHASES[Math.floor(Math.random() * RECENT_PURCHASES.length)];
        setCurrentPurchase(randomPurchase);
        setIsVisible(true);
      }, 2000); // Wait 2s before showing next one
    }, 20000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(cycleTimer);
    };
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 max-w-sm animate-fade-in-up transition-all duration-500" data-id="element-45">
      <div className="bg-white rounded-lg shadow-xl p-4 border-l-4 border-green-500 flex items-start gap-3 relative" data-id="element-46">
        <button onClick={() => setIsVisible(false)} className="absolute top-1 right-1 text-gray-400 hover:text-gray-600" aria-label="Cerrar notificación" data-id="element-47">
          <X size={14} data-id="element-48" />
        </button>

        <div className="bg-green-100 p-2 rounded-full flex-shrink-0" data-id="element-49">
          <CheckCircle className="w-6 h-6 text-green-600" data-id="element-50" />
        </div>

        <div data-id="element-51">
          <p className="text-sm font-bold text-gray-800" data-id="element-52">
            ¡Nueva compra realizada!
          </p>
          <p className="text-sm text-gray-600" data-id="element-53">
            <span className="font-semibold" data-id="element-54">{currentPurchase.name}</span> de{' '}
            {currentPurchase.city}
          </p>
          <p className="text-xs text-gray-500 mt-1" data-id="element-55">
            Compró Micro y Macro Economía 360
          </p>
        </div>
      </div>
    </div>;
}